import footerBadge from 'img/footer-badge.png'
import 'css/components/footer.css'

/* The mockups' footer social icons are 16px line SVGs stroked in currentColor
   inside a translucent disc -- see .social-links a in footer.css. They are
   inlined rather than imported as files because an <img> cannot inherit the
   footer's colour, which is what left staging showing the full-colour brand
   marks as two bright blue discs on the umber. */
const InstagramIcon = () => (
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<rect x="2" y="2" width="20" height="20" rx="5" />
		<circle cx="12" cy="12" r="4" />
		<circle cx="17.5" cy="6.5" r="1" />
	</svg>
)

const LinkedInIcon = () => (
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
		<rect x="2" y="9" width="4" height="12" />
		<circle cx="4" cy="4" r="2" />
	</svg>
)

export const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<img src={footerBadge} alt="Footer Logo" className="footer-logo" />
				<div className="footer-right">
					<div className="social-links">
						<a href="https://www.instagram.com/allforonelearn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon /></a>
						<a href="https://www.linkedin.com/company/all-for-one-afo/posts/?feedView=all" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedInIcon /></a>
					</div>
					{/* The mockup's footer carries the address alone -- no "Questions? Email"
					    lead-in, no copyright bar underneath. */}
					<p className="footer-text">
						<a href="mailto:hey@allforonelearn.com" className="footer-email">hey@allforonelearn.com</a>
					</p>
				</div>
			</div>
		</footer>
	)
}


export const StudentFooter = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<img src={footerBadge} alt="Footer Logo" className="footer-logo" />
				<div className="footer-right">
					<p className="footer-text footer-copyright">Copyright © {new Date().getFullYear()} All For One.</p>
				</div>
			</div>
		</footer>
	)
}
